var monitorH5 = {

}
window.monitorH5 = monitorH5
if (window.Vue) { // 自动绑定
  window.Vue.use(monitorH5)
}

export { monitorH5 }